import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { customAxios } from "lib/axios";
import { refetchUserOnError } from "utils/refetchUserOnError";

import { Holiday, HolidaysResponse } from "./getHoliday";
import { showNotification } from "@mantine/notifications";

const deleteHoliday = async (holidayId: string): Promise<Holiday> =>
  (await customAxios.delete<Holiday>(`/holidays/${holidayId}`)).data;

export const useDeleteHoliday = () => {
  const queryClient = useQueryClient();

  return useMutation<Holiday, AxiosError, string>({
    mutationFn: deleteHoliday,
    onSuccess: (_, holidayId) => {
      queryClient.setQueryData<HolidaysResponse>(["holidays"], (old) =>
        old
          ? { ...old, data: old.data.filter((h) => h._id !== holidayId) }
          : old
      );
      queryClient.removeQueries({
        queryKey: ["holidays", holidayId],
        exact: true,
      });
      showNotification({
        title: "Holiday Deleted",
        message: "The holiday has been successfully deleted.",
        color: "green",
      });
    },
    onError: (err) => {
      refetchUserOnError(err, queryClient);
    },
  });
};
